import React from 'react';

/**
 * ツールチップ
 * Reactではdocument.readyでイベントが引っかからないので、コンポーネントとして実装する。
 */
export default function Tooltip({
  message,
}: {
  message: string
}) {
  const tooltipRef = React.useRef(null);

  React.useEffect(() => {
    if (tooltipRef.current) {
      window.initializeTooltip(window.jQuery(tooltipRef.current));
    }
  }, []);

  return (
    <abbr ref={tooltipRef} rel="tooltip" title={message}><span className="question_icon" /></abbr>
  );
}
